export default [
  {
    path: "/yhcontract",
    component: () =>
      import("@/views/setting/operate/yhcontract/YhContract.vue"),
    meta: {
      title: "养护合同",
      activeMenu: "/yhcontract"
    },
  },
  {
    path: "/yhcontract/add",
    component: () =>
      import("@/views/setting/operate/yhcontract/YhContractAdd.vue"),
    meta: {
      title: "新增养护合同",
      activeMenu: "/yhcontract"
    },
  },
  {
    path: "/yhcontract/edit",
    name: "personnelUpdate",
    component: () =>
      import("@/views/setting/operate/yhcontract/YhContractAdd.vue"),
    meta: {
      title: "编辑养护合同",
      activeMenu: "/yhcontract"
    },
  },
  {
    path: "/yhcontract/details",
    component: () =>
      import("@/views/setting/operate/yhcontract/YhContractDetails.vue"),
    meta: {
      title: "养护合同详情",
      activeMenu: "/yhcontract"
    },
  },
  {
    path: "/costplanning",
    component: () =>
      import("@/views/setting/operate/costplanning/CostPlanning.vue"),
    meta: {
      title: "成本计划",
      activeMenu: "/costplanning"
    },
  },
  {
    path: "/costplanning/details",
    component: () =>
      import("@/views/setting/operate/costplanning/CostPlanningDetails.vue"),
    meta: {
      title: "成本计划明细详情",
      activeMenu: "/costplanning"
    },
  },
  {
    path: "/indirectcost",
    component: () =>
      import("@/views/setting/operate/indirectcost/IndirectCost.vue"),
    meta: {
      title: "间接费",
      activeMenu: "/indirectcost"
    },
  },
  {
    path: "/collectionmanage",
    component: () =>
      import("@/views/setting/operate/collectionmanage/CollectionManage.vue"),
    meta: {
      title: "回款管理",
      activeMenu: "/collectionmanage"
    },
  },
  {
    path: "/projectanalysis",
    component: () =>
      import("@/views/setting/operate/analysis/project/ProjectAnalysis.vue"),
    meta: {
      title: "项目经营分析",
      activeMenu: "/projectanalysis"
    },
  },
  {
    path: "/businessoverview",
    component: () =>
      import("@/views/setting/operate/analysis/overview/BusinessOverview.vue"),
    meta: {
      title: "经营总览",
      activeMenu: "/businessoverview"
    },
  },
  {
    path: '/laborcost',
    name: 'laborcost',
    meta: {
      title: '劳务包工',
      activeMenu: '/laborcost'
    },
    component: () => import('@/views/setting/operate/laborcost/LaborCost.vue')
  }
];
